import { Skeleton } from 'antd';
import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "ProductDetailstyle__Container",
  componentId: "sc-1wtsvgl-0"
})(["", " background-color:#F9F9F9;"], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center"
});
export const Wrapper = styled.div.withConfig({
  displayName: "ProductDetailstyle__Wrapper",
  componentId: "sc-1wtsvgl-1"
})(["", " max-width:", ";@media (max-width:", "){", "}"], {
  "width": "100%",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem"
}, ({
  theme
}) => `${theme.layout.width}`, ({
  theme
}) => theme.breakpoint.md, {
  "paddingTop": "2rem"
});
export const WrapperProduct = styled.div.withConfig({
  displayName: "ProductDetailstyle__WrapperProduct",
  componentId: "sc-1wtsvgl-2"
})(["", " @media (max-width:", "){", "}"], {
  "marginTop": "0.5rem",
  "display": "grid",
  "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
  "gap": "2rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gap": "1rem"
});
export const PackshotWrapper = styled.div.withConfig({
  displayName: "ProductDetailstyle__PackshotWrapper",
  componentId: "sc-1wtsvgl-3"
})(["", ""], {
  "marginTop": "1rem"
});
export const DetailWrapper = styled.div.withConfig({
  displayName: "ProductDetailstyle__DetailWrapper",
  componentId: "sc-1wtsvgl-4"
})(["", " @media (max-width:", "){", "}"], {
  "marginTop": "1rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
});
export const PackshotSkeleton = styled(Skeleton.Image).withConfig({
  displayName: "ProductDetailstyle__PackshotSkeleton",
  componentId: "sc-1wtsvgl-5"
})(["", " svg{", "}@media (max-width:", "){", "}"], {
  "aspectRatio": "1 / 1",
  "height": "auto !important",
  "width": "100% !important",
  "borderRadius": "0.5rem !important"
}, {
  "display": "none"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "1rem",
  "borderRadius": "0px !important"
});
export const PackshotOptionSkeleton = styled(Skeleton.Image).withConfig({
  displayName: "ProductDetailstyle__PackshotOptionSkeleton",
  componentId: "sc-1wtsvgl-6"
})(["", " svg{", "}"], {
  "aspectRatio": "1 / 1",
  "height": "auto !important",
  "width": "100px !important",
  "borderRadius": "0.5rem !important"
}, {
  "display": "none"
});
export const NavigationSkeleton = styled(Skeleton.Button).withConfig({
  displayName: "ProductDetailstyle__NavigationSkeleton",
  componentId: "sc-1wtsvgl-7"
})(["", ""], {
  "height": "3rem !important",
  "width": "100% !important",
  "borderRadius": "0.375rem !important"
});
export const TitleSkeleton = styled(Skeleton.Input).withConfig({
  displayName: "ProductDetailstyle__TitleSkeleton",
  componentId: "sc-1wtsvgl-8"
})(["", " @media (max-width:", "){", "}"], {
  "marginTop": "1rem",
  "height": "2.5rem !important",
  "width": "91.666667% !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "0.125rem",
  "height": "2rem !important"
});
export const DescriptionSkeleton = styled(Skeleton.Input).withConfig({
  displayName: "ProductDetailstyle__DescriptionSkeleton",
  componentId: "sc-1wtsvgl-9"
})(["", " @media (max-width:", "){", "}"], {
  "marginBottom": "0.375rem",
  "marginTop": "0.75rem",
  "width": "100% !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "0.375rem",
  "height": "1.5rem !important"
});
export const TagWrapper = styled.div.withConfig({
  displayName: "ProductDetailstyle__TagWrapper",
  componentId: "sc-1wtsvgl-10"
})(["", ""], {
  "display": "flex",
  "gap": "0.5rem"
});
export const CollapseWrapper = styled.div.withConfig({
  displayName: "ProductDetailstyle__CollapseWrapper",
  componentId: "sc-1wtsvgl-11"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});
export const CollapseSkeleton = styled.div.withConfig({
  displayName: "ProductDetailstyle__CollapseSkeleton",
  componentId: "sc-1wtsvgl-12"
})(["", ""], {
  "height": "auto !important",
  "width": "100% !important",
  "borderRadius": "1rem !important",
  "backgroundColor": "rgba(0, 0, 0, 0.06)",
  "padding": "1rem"
});
export const TitleWrapper = styled.div.withConfig({
  displayName: "ProductDetailstyle__TitleWrapper",
  componentId: "sc-1wtsvgl-13"
})(["", " .title{", "}"], {
  "marginBottom": "1.5rem",
  "display": "flex",
  "justifyContent": "space-between"
}, {
  "width": "80% !important"
});
export const ButtonWrapper = styled.div.withConfig({
  displayName: "ProductDetailstyle__ButtonWrapper",
  componentId: "sc-1wtsvgl-14"
})(["", ""], {
  "marginTop": "1rem",
  "marginBottom": "1rem",
  "display": "flex",
  "justifyContent": "flex-end",
  "gap": "0.5rem"
});